import React from "react";
import PropTypes from "prop-types";
import { Footer as ModalFooter } from "MODULES/shared/components/Modal";
import { Icon } from "MODULES/shared/components";

export default function Footer({ close, onConfirm }) {
  return (
    <ModalFooter>
      <button type="button" className="btn btn-default" onClick={close}>
        Cancel
      </button>
      <button type="submit" className={`btn btn-danger`} onClick={onConfirm}>
        <span>
          <Icon name="ban" fixed />
          Remove Line Item
        </span>
      </button>
    </ModalFooter>
  );
}

Footer.propTypes = {
  close: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/Cancel/Footer.jsx